import './payment-summary.scss';
import React from 'react';
import { roundUptoDigits } from '../../../../utils/helper';
import Panel from '../../../../mobile/components/Panel/Panel';
import { connect } from 'react-redux';

class PaymentSummary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      priceBreakUp: false,
      tooltipHover: false,
    };
    this.closepriceBreakUp = this.closepriceBreakUp.bind(this);
    this.tooltipHandle = this.tooltipHandle.bind(this);
  }
  closepriceBreakUp() {
    this.setState({ priceBreakUp: !this.state.priceBreakUp });
    // const { setPriceBreakup, priceBreakup } = this.props;
    // setPriceBreakup(!priceBreakup);
    const containerHeight = document.getElementById('payment-summary').offsetHeight;
    if (containerHeight < 70) {
      const finalHeight = document.body.scrollHeight;
      setTimeout(() => {
        window.scrollTo({
          top: finalHeight,
          behavior: 'smooth',
        });
      }, 100);
    }
  }
  tooltipHandle(hoverState) {
    const { tooltipHover } = this.state;
    if (hoverState === tooltipHover) return;
    this.setState({ tooltipHover: hoverState });
  }
  render() {
    const {
      totals = {},
      prepaidDiscount,
      exchange,
      dataLocale,
      currencyMark,
      retunConfirmPage,
      orderDetails,
    } = this.props;
    const {
      CURRENCY_CODE,
      CLOSED,
      FREE,
      SYMBOL_PLUS,
      HYPHEN,
      OLD_PRODUCT_EXCHANGE_VALUE,
      PAID,
      INCLUSIVE_OF_GST,
      TO_PE_PAID,
      AUTO_DISCOUNT,
      OLD_PRODUCT_DISCOUNT,
      GV,
      LK_CASH_PLUS,
      LK_CASH,
      CART_DISCOUNT,
      NEW_PRODUCT_PRICE,
      SUBTOTAL,
      ADDITIONAL_TAX,
      TAX,
      NET_AMOUNT_BEFORE_TAX,
      THE_ADJUSTED_TAX_AFTER_EXCHANGE_ORDER,
      STORE_CREDIT,
      PREPAID_DISCOUNT,
      CONVENIENCE_FEES,
      ORDER_TOTAL,
      VIEW_BREAKUP,
    } = dataLocale;
    const isPaymentCOD = orderDetails?.result?.orders?.[0]?.payments?.totalCOD > 0;
    const isOrderStatusClosed = orderDetails?.result?.orders?.[0]?.status?.status === CLOSED;
    let amountPaid = false;
    if (isPaymentCOD && !isOrderStatusClosed) amountPaid = false;
    else amountPaid = true;
    const { discounts = [] } = totals;
    const { priceBreakUp, tooltipHover } = this.state;
    const scObj = [];
    const exchangeObj = [];
    const implicitObj = [];
    const DISCOUNTS = {
      implicit: CART_DISCOUNT,
      lenskart: LK_CASH,
      lenskartplus: LK_CASH_PLUS,
      gv: GV,
      sc: STORE_CREDIT,
      prepaid: PREPAID_DISCOUNT,
      exchange: OLD_PRODUCT_DISCOUNT,
    };
    const EXCHANGEDISCOUNTS = { implicit: AUTO_DISCOUNT, exchange: OLD_PRODUCT_EXCHANGE_VALUE };
    let scAmt = 0;
    const currencyCode = totals.currencyCode || CURRENCY_CODE;
    const currencySymbol = <span>{currencyMark[currencyCode]}</span>;
    for (let i = 0, length = discounts.length; i < length; i++) {
      if (discounts[i].type === 'sc') {
        scAmt += discounts[i].amount;
        scObj.push(discounts[i]);
      } else if (exchange && discounts[i].type === 'exchange') {
        exchangeObj.push(discounts[i]);
      } else if (discounts[i].type === 'implicit') {
        implicitObj.push(discounts[i]);
      }
    }
    let netAmount = totals.subTotal;
    if (exchange) {
      if (implicitObj[0]) {
        netAmount = roundUptoDigits(totals.subTotal - implicitObj[0].amount, 2);
      }
    } else {
      netAmount = roundUptoDigits(totals.subTotal - (totals.totalDiscount - scAmt), 2);
    }
    netAmount = netAmount > 0 ? netAmount : 0;

    return (
      <div
        className={`payment-summary ${
          exchange ? '' : 'pd-l15 pd-r15 pd-b5 padding-7'
        } bg-color_white margin-t20 fsp13 bora-2 mr-b20`}
        id="payment-summary"
      >
        <div className="pd-t12 pd-b8 fw500 items-count">
          <span
            className={`${
              retunConfirmPage && amountPaid ? 'text-green' : 'text-red'
            } fw400 fs20 mr-r8 valign-middle`}
          >
            {currencySymbol}
            {Math.max(0, totals.total - (prepaidDiscount || 0)).toFixed(2)}
          </span>
          <span
            className={`${
              retunConfirmPage && amountPaid ? 'text-green' : 'text-red'
            } fs20 fw400 lh-20 valign-middle`}
          >
            {' '}
            {retunConfirmPage && amountPaid ? PAID : TO_PE_PAID}
          </span>
          <span
            className="fs14 margin-t5 lh-20 text-color-primary mr-t5 pull-right"
            onClick={this.closepriceBreakUp}
          >
            {VIEW_BREAKUP}
            <span
              className={`icon fsp11 pd-l4 ${priceBreakUp ? 'icon-up-open' : 'icon-down-open'}`}
            ></span>
          </span>
        </div>
        <div className="text-color-grey margin-b14">
          <span>{INCLUSIVE_OF_GST}</span>
        </div>
        <Panel expanded={priceBreakUp}>
          <div className="display-flex text-color-grey fw500 justify-space-between pd-t10 fs14 border-top">
            <div className="margin-t12 margin-b12">{exchange ? NEW_PRODUCT_PRICE : SUBTOTAL}</div>
            <div className="margin-t12 margin-b12 text-color-grey fw500">
              {currencySymbol}
              {totals.subTotal}
            </div>
          </div>
          {discounts.length > 0 &&
            discounts.map(discount => {
              if (discount.type !== 'sc') {
                return (
                  <React.Fragment key={discount.type}>
                    {exchange ? (
                      <React.Fragment>
                        {discount.type === 'implicit' && (
                          <div
                            key={discount.type}
                            className="display-flex margin-t6 margin-b6 text-color-grey justify-space-between mr-t10 fsp14 discount-data"
                          >
                            <div>{EXCHANGEDISCOUNTS[discount.type]}</div>
                            <div className="fw500">
                              {HYPHEN} {currencySymbol}
                              {roundUptoDigits(discount.amount, 2)}
                            </div>
                          </div>
                        )}
                      </React.Fragment>
                    ) : (
                      <div
                        key={discount.type}
                        className="display-flex text-color-grey margin-t6 margin-b6 justify-space-between mr-t10 fsp14 discount-data"
                      >
                        <div>{DISCOUNTS[discount.type]}</div>
                        <div className="fw500">
                          {HYPHEN} {currencySymbol}
                          {roundUptoDigits(discount.amount, 2)}
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                );
              }
              return null;
            })}
          <div className="mr-t10 pd-b10 pd-t10 fs14 net-amount-before-tax ">
            <div className="display-flex justify-space-between fs14">
              <span className=" margin-t12 margin-b6 fw500">{NET_AMOUNT_BEFORE_TAX}</span>
              <div className=" margin-t12 margin-b6 fw500">
                {currencySymbol}
                {netAmount}
              </div>
            </div>
            <div className="display-flex fs14 justify-space-between mr-t10 text-cool_grey">
              <div className="margin-t6 fw500 text-color-grey margin-b6">
                {exchange ? ADDITIONAL_TAX : TAX}{' '}
                {exchange && (
                  <React.Fragment>
                    <span
                      className="inline-block"
                      onClick={this.tooltipHandle.bind(this, true)}
                      onMouseLeave={this.tooltipHandle.bind(this, false)}
                    >
                      <img
                        alt="title"
                        className="valign-middle"
                        src="https://static.lenskart.com/media/mobile/universal/assets/ic_info.png"
                        style={{ height: '14px' }}
                      />
                    </span>
                    <div
                      className="tax-tooltip"
                      style={{ display: tooltipHover ? 'block' : 'none' }}
                    >
                      {THE_ADJUSTED_TAX_AFTER_EXCHANGE_ORDER}
                    </div>
                  </React.Fragment>
                )}
              </div>
              <div className=" margin-t12 text-color-grey margin-b6 fw500">
                {SYMBOL_PLUS} {currencySymbol}
                {roundUptoDigits(totals.totalTax, 2)}
              </div>
            </div>
            {exchangeObj.length > 0 && (
              <div className="display-flex fs14 justify-space-between mr-t10 text-cool_grey">
                <div className="margin-t6 text-color-grey fw500 margin-b6">
                  {EXCHANGEDISCOUNTS[exchangeObj[0].type]}
                </div>
                <div className="margin-t6 text-color-grey margin-b6 fw500">
                  {HYPHEN} {currencySymbol}
                  {roundUptoDigits(exchangeObj[0].amount, 2)}
                </div>
              </div>
            )}
            {scAmt > 0 && (
              <div className="store-credit fs14 display-flex justify-space-between mr-t10 fsp14 text-cool_grey">
                <div className="margin-t6 text-color-grey fw500 margin-b6">{STORE_CREDIT}</div>
                <div className="margin-t6 text-color-grey margin-b6 fw500">
                  {HYPHEN} {currencySymbol}
                  {scAmt}
                </div>
              </div>
            )}
            {Boolean(prepaidDiscount) && (
              <div className="prepaid-discount fs14 display-flex justify-space-between mr-t10 fsp14 text-cool_grey">
                <div className="margin-t6 text-color-grey fw500 margin-b6">{PREPAID_DISCOUNT}</div>
                <div className=" margin-t6 text-color-grey margin-b6 fw500">
                  {HYPHEN} {currencySymbol}
                  {roundUptoDigits(prepaidDiscount, 2)}
                </div>
              </div>
            )}
            <div className="display-flex fs14 justify-space-between mr-t10 text-cool_grey">
              <div className="margin-t6 text-color-grey fw500 margin-b6">{CONVENIENCE_FEES}</div>
              <div
                className={`fw500 ${
                  !totals.shipping ? 'text-color-primary' : ''
                }margin-t6 text-color-grey margin-b6`}
              >
                {totals.shipping ? (
                  <span>
                    {SYMBOL_PLUS} {currencySymbol}
                    {roundUptoDigits(totals.shipping, 2)}
                  </span>
                ) : (
                  <span className="text-uppercase">{FREE}</span>
                )}
              </div>
            </div>
          </div>
          <div className="display-flex fs14 justify-space-between mr-t5 pd-b10 pd-t12 totals fsp15">
            <div className="margin-t12 margin-b12 fw500">{ORDER_TOTAL}</div>
            <div className="margin-t12 margin-b12 fw500">
              {currencySymbol}
              {Math.max(0, totals.total - (prepaidDiscount || 0)).toFixed(2)}
            </div>
          </div>
        </Panel>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currencyMark: state.common.currencyMark,
    orderDetails: state.order.orderDetails,
  };
}

export default connect(mapStateToProps, null)(PaymentSummary);
